import cn from "classnames";
import { Link as RouterLink } from "react-router-dom";
import { IKBPageSmall } from "src/widgets/KnowledgeBase/types";

import styles from "./DocLink.module.scss";

interface DocLinkProps {
  basePath: string;
  sectionSlug: string;
  doc: IKBPageSmall;
  onClick?: () => void;
  currentSlugPath: string;
}

export const DocLink = ({
  basePath,
  sectionSlug,
  doc,
  currentSlugPath,
  onClick,
}: DocLinkProps) => {
  const fullPath = `${sectionSlug}/${doc.slug}`;
  const isActive = currentSlugPath === fullPath;

  return (
    <div className={styles.leaf}>
      <RouterLink
        to={`${basePath}${fullPath}`}
        className={cn(
          styles.linkRouter,
          isActive ? styles.activeLink : styles.defaultLink,
        )}
        onClick={onClick}
      >
        {doc.title}
      </RouterLink>
    </div>
  );
};
